import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AddStudentWizardContext } from 'context/Context';

const AddStudentWizardProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [step, setStep] = useState(1);

  const value = { user, setUser, step, setStep };
  return (
    <AddStudentWizardContext.Provider value={value}>
      {children}
    </AddStudentWizardContext.Provider>
  );
};

AddStudentWizardProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default AddStudentWizardProvider;
